<script>
	import { onMount } from 'svelte'

	export let chapters_csv
	export let video_key

	let details_element

	const crudely_parse_csv = csv_string => csv_string
		.split(`\n`)
		.filter(row => row.trim().length)
		.map(row => row.includes(`|`) ? row.split(`|`) : row.split(`,`))

	const chapters = crudely_parse_csv(chapters_csv)

	onMount(() => {
		if (document.body.clientWidth > 900) {
			details_element.open = true
		}
	})
</script>

<details bind:this={details_element}>
	<summary>
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>
		Chapters
	</summary>

	<ol>
		{#each chapters as [ seconds, name ]}
			<li><a href="javascript:video_{video_key}_goto_time({seconds})">{name}</a></li>
		{/each}
	</ol>
</details>

<style>
	details {
		width: 100%;
		border: 3px solid #333;
		border-radius: 5px;
	}

	details[open] :global(svg.feather-chevron-right) {
		transform: rotate(90deg);
	}

	summary {
		display: flex;
		padding: 10px;
		cursor: pointer;
		gap: 8px;
	}

	/* Hide the browser's default arrow https://stackoverflow.com/a/56649741 */
	summary { list-style: none; }
	summary::-webkit-details-marker { display: none; }

	ol {
		margin: 0 10px 10px;
		column-width: 280px;
		overflow: hidden;
		transition: all 0.5s ease-in-out;
	}

	details li {
		/* This needs the "details" in the selector because we're fighting with ".page-post-content li" for specificity */
		font-size: 12px;
		margin: 2px 10px 2px 20px;
		list-style-position: outside;
	}
</style>
